import React, { ReactNode } from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

import { Position } from './utils';

interface DraggableContentProps {
  children: ReactNode;
  className?: string;
  position: Position;
}

export const DraggableContent = React.forwardRef<HTMLDivElement, DraggableContentProps>(
  ({ children, className, position }, ref) => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
      id: 'floating-draggable',
    });

    const style = {
      position: 'fixed' as const,
      left: `${position.x}px`,
      top: `${position.y}px`,
      transform: CSS.Transform.toString(transform),
      zIndex: 50,
      cursor: isDragging ? 'grabbing' : 'grab',
      touchAction: 'none' as const,
      userSelect: 'none' as const,
    };

    return (
      <div
        ref={(node) => {
          setNodeRef(node);
          if (ref && typeof ref !== 'function') {
            ref.current = node;
          }
        }}
        style={style}
        className={className}
        {...listeners}
        {...attributes}
      >
        {children}
      </div>
    );
  }
);

DraggableContent.displayName = 'DraggableContent';
